import { START_NODE_ID } from '@jira/project-settings__workflow-types/src/workflowConstants.tsx';
import { isStartNodeReference } from './isEveryPropertyDefined.tsx';
import type { ItemReference, Positionable } from './ListEdgeDetails.tsx';
import type { Point, StartNode } from './toPortInfo.tsx';

export interface Options {
	startNodePosition: Point | undefined;
	targetedItem: ItemReference | undefined;
	hoveredItem: ItemReference | undefined;
	draggingItem: Positionable | undefined;
	movingItem: Positionable | undefined;
	defaultPositions: Record<string, Point>;
}

export const useStartNode = ({
	startNodePosition,
	targetedItem,
	hoveredItem,
	draggingItem,
	movingItem,
	defaultPositions,
}: Options): StartNode => {
	let position = startNodePosition || defaultPositions[START_NODE_ID];
	const isDragging = draggingItem?.type === 'start-node';
	const isMoving = movingItem?.type === 'start-node';

	if (isDragging) {
		position = draggingItem.position;
	}

	if (isMoving) {
		position = movingItem.position;
	}

	return {
		id: START_NODE_ID,
		position,
		isTargeted: isStartNodeReference(targetedItem),
		isHovered: isStartNodeReference(hoveredItem),
		isDragging,
		isMoving,
	};
};
